export const MONITORING_OPTIN = 'optin';
export const MONITORING_OPTOUT = 'optout';
export const MONITORING_EXEMPTED = 'exempted';
export const MONITORING_EXEMPT = 'exempt';
export const MONITORING_CLIENT_OPTOUT = 'OPT-OUT';
export const MONITORING_UNCONSENTED = 'unconsented';
export const MONITORING_CONSENTED = 'consented';
